import {Component, OnInit, ElementRef} from "@angular/core";


/**
 * List of classes to add to Button instances based on host attributes to
 * style as different variants.
 */
const BUTTON_HOST_ATTRIBUTES = [
  'tfPrimaryButton',
  'tfFeaturedButton',
  'tfInfoButton',
  'tfLinkButton',
  'tfSecondaryButton'
];

const StyleClassesForHostAttributes = {
  'tfPrimaryButton': ['tf-btn', 'tf-btn-primary'],
  'tfFeaturedButton': ['tf-btn', 'tf-btn-featured'],
  'tfInfoButton': ['tf-btn', 'tf-btn-info'],
  'tfLinkButton': ['tf-btn', 'tf-btn-link'],
  'tfSecondaryButton': ['tf-btn', 'tf-btn-secondary']
};

@Component({
  selector: 'button[tfPrimaryButton],button[tfFeaturedButton],button[tfInfoButton],button[tfLinkButton],button[tfSecondaryButton]',
  templateUrl: 'tf-buttons.component.html',
  styleUrls: ['tf-buttons.component.scss'],
  inputs: ['disabled', 'size', 'color'],
  host: {
    '[disabled]': 'disabled || null'
  }
})
export class TfButtonComponent implements OnInit {

  /** Whether the tf-buttons is block. */
  readonly isBlockButton: boolean = false;

  size: string;
  disabled: boolean;
  color: string;

  constructor(private _elementRef: ElementRef) {

    for (const attr of BUTTON_HOST_ATTRIBUTES) {
      if (this._hasHostAttributes([attr])) {
        StyleClassesForHostAttributes[attr].forEach((className) => {
          className != "none" && (this._getHostElement() as HTMLElement).classList.add(className);
        });
      }
    }

  }

  ngOnInit() {
    this._addClasses();
  }

  _addClasses = () => {
    if (this.size) {
      const className = this.size == 'lg' ? 'tf-btn-lg' : this.size == 'sm' ? 'tf-btn-sm' : this.size == 'mini' ? 'tf-btn-mini' : 'none';
      className != "none" && (this._getHostElement() as HTMLElement).classList.add(className);

    }
    if (this.isBlockButton) {
      (this._getHostElement() as HTMLElement).classList.add('btn-block');
    }
    if (this.color) {
      (this._getHostElement() as HTMLElement).style.color = this.color;
    }
  };

  _getHostElement() {
    return this._elementRef.nativeElement;
  }

  /** Focuses the tf-buttons. */
  focus(): void {
    this._getHostElement().focus();
  }

  /** Gets whether the tf-buttons has one of the given attributes. */
  _hasHostAttributes(attributes: string[]) {
    return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
  }

}
